export const getAppProps = (pageWithProviders, pageType, physicalProduct) => ({ pageWithProviders, pageType, physicalProduct });
